import { OrdersComponent } from './orders.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonComponentsModule } from '@app/modules/common/common.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OrderPayComponent } from '@app/components/order-pay/order-pay.component';
import { PipesModule } from '@app/pipes/pipes.module';

export const routes: Routes = [
    {
        path: '',
        component: OrdersComponent,
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        CommonComponentsModule,
        FormsModule,
        CommonModule,
        PipesModule
    ],
    declarations: [
        OrdersComponent,
        OrderPayComponent
    ],
    exports: [
        OrderPayComponent
    ]
})

export class OrdersModule {

}
